export default "__VITE_ASSET__ChpkSrNQ__"